import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39871109"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mr-1 text-size-14 text-mild"
}
const _hoisted_2 = {
  key: 2,
  class: "mr-1 text-size-12 text-mild"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLabel = _resolveComponent("AppLabel")!
  const _component_AppRadio = _resolveComponent("AppRadio")!
  const _component_FormInvalidFeedback = _resolveComponent("FormInvalidFeedback")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.appLabelText)
      ? (_openBlock(), _createBlock(_component_AppLabel, {
          key: 1,
          variant: "red"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.appLabelText), 1)
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("div", {
      class: _normalizeClass([
        `radio-group flex-${_ctx.flexDirection} d-flex mt-2`,
        { stacked: _ctx.variant === 'stacked' }
      ])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.value,
          class: "radio-group__item"
        }, [
          _createVNode(_component_AppRadio, {
            disabled: _ctx.disabled,
            name: _ctx.name,
            modelValue: option.value,
            "onUpdate:modelValue": ($event: any) => ((option.value) = $event),
            id: `${_ctx.name}-option-${option.value}`,
            text: option.text,
            checked: _ctx.value === option.value,
            onChange: _ctx.onChange,
            "has-border": _ctx.hasBorder,
            size: _ctx.size
          }, null, 8, ["disabled", "name", "modelValue", "onUpdate:modelValue", "id", "text", "checked", "onChange", "has-border", "size"])
        ]))
      }), 128))
    ], 2),
    _createTextVNode(),
    (_ctx.validationState)
      ? (_openBlock(), _createBlock(_component_FormInvalidFeedback, {
          key: 3,
          "validation-state": _ctx.validationState,
          state: false
        }, null, 8, ["validation-state"]))
      : _createCommentVNode("", true)
  ]))
}